<template>
    <base-dialog :value="dialog" :width="560" :title="title"
        @input="val => { if (!val) hide() }" @close="hide">
        <div v-if="currentLink" class="video-wrap">
            <youtube-iframe :link="{ videoId: currentLink.videoId }" height="100%" />
        </div>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import YoutubeIframe from "@/components/common/YoutubeIframe";

export default {
    name: "AgendaVideoDialog",
    components: { BaseDialog, YoutubeIframe },
    data() {
        return {
            dialog: false,
            currentLink: null,
        }
    },
    computed: {
        title(vm = this) {
            return vm.currentLink?.name || vm.$t('exercises.watch_video')
        },
    },
    methods: {
        show(link) {
            const vm = this
            vm.currentLink = link
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.$nextTick(() => { vm.currentLink = null })
        },
    },
}
</script>

<style scoped>
.video-wrap {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 8px;
    overflow: hidden;
    background: #000;
}

.video-wrap >>> #player,
.video-wrap >>> .youtube-thumb {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    border-radius: 8px;
}
</style>
